import React from 'react';

interface PageProps {
    children: React.ReactNode;
    style?: React.CSSProperties;
}

const Page = ({ children, style }: PageProps) => {
    return (
        <div
             className="pageBreakAfter"
            style={{
                maxWidth: '100%',
                height: '1055px',
                minHeight: '1055px',
                margin: '0 auto',
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
                ...style,
            }}
        >
            <div
                style={{
                    width: '100%',
                    backgroundColor: '#5BA1C5',
                    height: '35px',
                    position: 'absolute',
                    top: '0',
                }}
            />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '20px',
                }}
            >
                {children}
            </div>
            <div
                style={{
                    width: '100%',
                    backgroundColor: '#A3BDC7',
                    height: '35px',
                    textAlign: 'center',
                    color: 'white',
                    position: 'absolute',
                    bottom: '0',
                }}
            >
                <div
                    style={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        letterSpacing: '2px',
                    }}
                >
                    relo{' '}
                    <span
                        style={{
                            backgroundColor: '#FFD700',
                            color: '#333',
                            padding: '1px 2px',
                            marginLeft: '4px',
                        }}
                    >
                        EDGE
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Page;
